import type { PbjPrediction } from "../../../utils/models";

// Map a raw point total to the star band it lands in. Mirrors the BE
// `lookup_stars` semantics: truncate toward zero first, then match the integer
// against the inclusive [min, max] tiers. The truncate step matters whenever a
// fractional input is fed in (simulator slider with step=0.5, rescaled BE
// totals, etc.) — without it 204.5 falls between band 2 (≤204) and band 3
// (≥205) and would wrong-fall-back to 1★ on the FE while the BE returns 2★.
export const ratingFromPoints = (points: number, thresholds: PbjPrediction["starThresholds"]): number => {
	const truncated = points >= 0 ? Math.trunc(points) : 0;
	const found = thresholds.find((t) => truncated >= t.min && truncated <= t.max);
	return found ? found.star : 1;
};
